import { z } from 'zod';

export const updateUserSettingsSchema = z.object({
  emailSignature: z.string().max(2000).nullable().optional(),
});

export type UpdateUserSettingsInput = z.infer<typeof updateUserSettingsSchema>;
